export default {"src":"/_next/static/media/sad-face.78139487.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};